import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text'

import { PenetapanNotAllowed } from 'api/kinerja/kepala-sekolah/config'
import usePenetapanGuard from 'app/KinerjaDinasPage/hooks/usePenetapanGuard'

export function PageGuardPenetapan({ children }) {
  const { isEnabled, isStarted, isLoadingConfig } = usePenetapanGuard()
  const router = useRouter()

  if (isLoadingConfig) {
    return (
      <div
        aria-busy="true"
        className="flex flex-col items-center justify-center space-y-2"
      >
        <Spinner />
        <Text>Memuat...</Text>
      </div>
    )
  }

  if (!isEnabled || !isStarted) {
    throw new PenetapanNotAllowed(router.asPath, new Error('Unauthorized'))
  }

  return children
}
